import CallApp from 'callapp-lib'
import { HtmlUtil } from './HtmlUtil'

let callApp: CallApp | null = null

export class BrowserUtil {
  public static isHarmony(): boolean {
    return this.getUA().toLocaleLowerCase().indexOf('harmony') > -1
  }

  public static isAndroid(): boolean {
    const ua = this.getUA()
    return ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
  }

  public static isIOS(): boolean {
    if (navigator.vendor) {
      if (navigator.vendor.includes('Apple Computer')) {
        return true
      }
    }
    return !!this.getUA().match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  }

  public static isWechat(): boolean {
    const lowerCaseUA = this.getUA().toLowerCase()
    return lowerCaseUA.indexOf('micromessenger') !== -1
  }

  public static isWxWork(): boolean {
    const lowerCaseUA = this.getUA().toLowerCase()
    return lowerCaseUA.indexOf('wxwork') !== -1
  }

  public static isWeapp(): boolean {
    const lowerCaseUA = this.getUA().toLowerCase()
    return (window as any).__wxjs_environment === 'miniprogram' || lowerCaseUA.indexOf('miniprogram') !== -1
  }

  public static isWechatOfficial(): boolean {
    return this.isWechat() && !this.isWxWork() && !this.isWeapp()
  }

  public static isUnderApp(): boolean {
    return (
      this.getUA().includes('com.gkid.crazyrope') ||
      this.getUA().includes('tiantiantiaosheng') ||
      this.getUA().includes('com.jumpstar') ||
      this.getUA().includes('com.tizhiyun') ||
      this.getUA().includes('com.xiaoyu')
    )
  }

  public static isUnderJumpstar(): boolean {
    return this.getUA().includes('com.jumpstar')
  }

  public static isUnderTzyApp(): boolean {
    return this.getUA().includes('com.tizhiyun')
  }

  public static isUnderUnity(): boolean {
    return this.isUnderApp() && this.getUA().toLowerCase().includes('unity')
  }

  public static getUA(): string {
    return navigator.userAgent
  }

  public static isMobile(): boolean {
    return document.documentElement.clientWidth < 760
  }

  public static updateTitle(title: string) {
    document.title = title
  }

  public static log(data: any) {
    // eslint-disable-next-line no-console
    console.log(data)
  }

  public static logError(e: Error) {
    this.log('========== ERROR =========')
    this.log(e)
  }

  // 页面在app里放后台的会后停止所有播放
  public static setStopAllPlayerWhenBackgroundListener() {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        this.pauseAllPlayers()
      }
    })
    window.addEventListener(
      'pagehide',
      (event) => {
        if (event.persisted) {
          this.pauseAllPlayers()
        }
      },
      false
    )
  }

  public static pauseAllPlayers() {
    const videos = document.getElementsByTagName('video')
    for (const v of (videos as unknown) as HTMLVideoElement[]) {
      const ele = v
      ele.pause()
    }
    const audios = document.getElementsByTagName('audio')
    for (const v of (audios as unknown) as HTMLAudioElement[]) {
      const ele = v
      ele.pause()
    }
  }

  public static setThemeColor(color: string) {
    HtmlUtil.appendMeta('theme-color', color)
    HtmlUtil.appendMeta('msapplication-navbutton-color', color)
    HtmlUtil.appendMeta('apple-mobile-web-app-capable', 'yes')
    HtmlUtil.appendMeta('apple-mobile-web-app-status-bar-style', color)
  }

  public static removeThemeColor() {
    this.setThemeColor('')
  }

  public static openLink(v: string, qd = '') {
    if (BrowserUtil.isAndroid()) {
      if (BrowserUtil.isWechat()) {
        const mask = document.createElement('div')
        mask.className = 'wx-browser-open-tips-mask'
        mask.addEventListener('click', function () {
          this.remove()
        })
        return document.body.appendChild(mask)
      }
      const fb = `https://www.tiantiantiaosheng.com/dl?qd=${qd}`
      callApp = callApp || new CallApp({ scheme: { protocol: 'gkid' }, appstore: fb, fallback: fb, timeout: 3000 })
      callApp.open({
        path: 'com.gkid.crazyrope/commonjump',
        param: {
          para: encodeURIComponent(
            JSON.stringify({
              action: 'jump',
              Android_page: 'com.gkid.crazyrope.ui.base.WebActivity',
              Android_param: { url: v },
            })
          ),
        },
      })
    } else location.href = `https://www.tiantiantiaosheng.com?cr_type=h5&cr_url=${encodeURIComponent(v)}`
  }

  public static fixIosWhiteScreenBug() {
    // trick: https://github.com/vuejs/vue/issues/5533#issuecomment-301982923
    if (this.isIOS()) {
      window.scrollTo(0, 1)
      window.scrollTo(0, 0)
    }
  }
}
